import { Controller } from "@hotwired/stimulus"

// Public storefront's "please log in" modal: focus the quick-login link
// as soon as the modal finishes opening, so keyboard/screen-reader users
// land somewhere useful immediately.
export default class extends Controller {
  static targets = ["focus"]

  connect() {
    this.element.addEventListener("shown.bs.modal", this.focus)
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.modal", this.focus)
  }

  focus = () => {
    this.focusTarget.focus()
  }
}
